// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","copyright":"Footer_copyright__JQMtz","links":"Footer_links__wMgLO"};